var LayoutPrimary = /** @class */ (function () {
    //Methods
    function LayoutPrimary(target) {
        var thisObj = this;
        this.disableFormButtonsOnSubmit();
        this.wrapTrademarkSymbolsWithSuperscriptTag();
        console.log('LayoutPrimary initialized');
        //Get all linked elements
        this.target = target;
        //Make it so every submit button found in every form on the site is diabled when the form is submitted (solves numerous issues)
        //Fixes include the "The provided anti-forgery token was meant for user "", but the current user is "ACT-2JFD6AMVSN7C"." which is caused by users double-clicking on the login button
        //Note that this is NOT for security, as users can diable JS. This is only for avoiding user-unfriendly or confusing error messages
        Apfco.SetDisableFormButtonsOnSubmit(this.target);
        //Wrap all registered trademark symbols with <sup>, as it applies to almost every design mockup we receive - see here https://stackoverflow.com/questions/19364581/adding-superscript-sup-tags-around-all-trademark-and-registered-trademark-symb
        var regexp = /[\xAE]/;
        $('body :not(script,sup)').contents().filter(function () {
            return this.nodeType === 3 && (regexp.test(this.nodeValue));
        }).replaceWith(function () {
            return this.nodeValue.replace(regexp, '<sup>$&</sup>');
        });
        $('body :not(script,sup)').contents().filter(function () {
            return this.nodeType === 3;
        }).replaceWith(function () {
            return this.nodeValue.replace(/[™®©]/g, '<sup>$&</sup>');
        });
        //Bootstrap v4 - Hack to fix double-click requirement of navbar drop-downs. Click them once to bypass, and then hide/blur in cases where a particular browswer does actually display them
        $(".dropdown-toggle").trigger("click");
        $('.dropdown').removeClass('show');
        $('.dropdown-toggle').attr('aria-expanded', 'false');
        $('.dropdown-menu').removeClass('show');
        $(".dropdown-toggle").blur();
        //Set the default focus to the first non-hidden input on all pages with a form. Makes pages easier to fill out with the keyboard
        if (document.getElementsByTagName('form').length > 0) {
            $('form:first *:input[type!=hidden]:first').focus();
        }
        //Apply datatables sort to all bootstrap tables in the site
        $(this.target).find('table.table').not('.noDataTable').each(function () {
            $(this).DataTable({
                "paging": false,
                "info": false,
                "searching": false,
                "aaSorting": [] //Make it so Datatables doesn't apply a default sort on page load - https://datatables.net/forums/discussion/1399/how-to-no-sort-by-default
            });
        });
        //Bootstrap v4 - enable tooltips everwhere: https://getbootstrap.com/docs/4.0/components/tooltips/
        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });
    }
    LayoutPrimary.prototype.disableFormButtonsOnSubmit = function () {
        //Make it so every submit button found in every form on the site is diabled when the form is submitted (solves numerous issues)
        //Fixes include the "The provided anti-forgery token was meant for user "", but the current user is "ACT-2JFD6AMVSN7C"." which is caused by users double-clicking on the login button
        //Note that this is NOT for security, as users can diable JS. This is only for avoiding user-unfriendly or confusing error messages
        $(this.target).find('form').each(function () {
            $(this).submit(function (event) {
                $(this).find(':input[type=submit]').each(function () {
                    if (!$(this).attr('apfDontDisableOnSubmit')) { //Don't disable if the apfDontDisableOnSubmit="true" attribute exists on the button
                        $(this).prop('disabled', true);
                    }
                });
            });
        });
        $(this.target).find('form').each(function () {
            var currentForm = this; //Get the current form
            $(this).find(':input[type=submit]').each(function () {
                if (!$(this).attr('apfDontDisableOnSubmit')) { //Don't disable if the apfDontDisableOnSubmit="true" attribute exists on the button
                    $(this).click(function (event) {
                        $('<input>').attr({
                            type: 'hidden',
                            name: $(this).attr('name'),
                            value: $(this).val()
                        }).insertBefore($(currentForm).children().first()); //Append to the start of the current form, instead of next to the button itself or the end of the form. Otherwise it may mess with any last-child CSS selectors
                    });
                }
            });
        });
    };
    LayoutPrimary.prototype.wrapTrademarkSymbolsWithSuperscriptTag = function () {
        //Wrap all registered trademark symbols with <sup>, as it applies to almost every design mockup we receive - see here https://stackoverflow.com/questions/19364581/adding-superscript-sup-tags-around-all-trademark-and-registered-trademark-symb
        var regexp = /[\xAE]/;
        $('body :not(script,sup)').contents().filter(function () {
            return this.nodeType === 3 && (regexp.test(this.nodeValue));
        }).replaceWith(function () {
            return this.nodeValue.replace(regexp, '<sup>$&</sup>');
        });
        $('body :not(script,sup)').contents().filter(function () {
            return this.nodeType === 3;
        }).replaceWith(function () {
            return this.nodeValue.replace(/[™®©]/g, '<sup>$&</sup>');
        });
    };
    return LayoutPrimary;
}());
//On page load, take all found elements with the classname and create objects for them to initialize
var layoutPrimaryList = [];
$(function () {
    var elementsByClass = document.getElementsByClassName("LayoutPrimary");
    for (var i = 0; i < elementsByClass.length; i++) {
        layoutPrimaryList.push(new LayoutPrimary(elementsByClass.item(i)));
    }
    ;
});
//# sourceMappingURL=ViewSharedLayoutPrimary.js.map